type Params = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (cmd: string, name: string, params?: Params) => void;
    dataLayer?: unknown[];
  }
}

export const track = (name: string, params: Params = {}): void => {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch {
    void 0;
  }
};
